// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebaseConfig: {
    apiKey: "AIzaSyAO8KqGD818WCm01oovS2VlFqJmN-G9qFE",
    authDomain: "cosasymas-app-67617.firebaseapp.com",
    databaseURL: "https://cosasymas-app-67617.firebaseio.com",
    projectId: "cosasymas-app-67617",
    storageBucket: "cosasymas-app-67617.appspot.com",
    messagingSenderId: "153645666481",
    appId: "1:153645666481:web:b784976e80d10cbbc2d290",
    measurementId: "G-CD8V2E2Z8B"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
